import React from 'react';
import { Segmented, Avatar, Tag } from 'antd';

// Her cocuga sabit bir renk - isimden turetiliyor, boylece ayni cocuk her
// acilista ayni rengi aliyor. Cok cocuklu velilerde sekmeleri gozle ayirt
// etmeyi kolaylastiriyor.
const PALETTE = ['#722ed1', '#13c2c2', '#fa8c16', '#eb2f96', '#52c41a', '#1677ff', '#f5222d'];

// djb2 - basit karakter toplamı iki farkli ismi ayni renge dusurebiliyordu
// (or. "Esmanur ..." ve "Kübra ..." ikisi de yesil cikiyordu), bu yuzden
// harflerin sirasini da hesaba katan bir hash kullaniliyor.
const hash = (str = '') => {
  let h = 5381;
  for (let i = 0; i < str.length; i++) h = ((h << 5) + h + str.charCodeAt(i)) >>> 0;
  return h;
};

/**
 * Grup icin renk atamasi: once isimden turetilen renk denenir, o renk grupta
 * baska bir cocuk tarafindan alinmissa bir sonraki bos renge kaydirilir.
 * Boylece hem renk isme bagli/kalici olur hem de kardesler asla ayni rengi
 * almaz.
 */
export const assignChildColors = (children = []) => {
  const used = new Set();
  const map = {};
  children.forEach((c) => {
    let idx = hash(c.name || '') % PALETTE.length;
    for (let step = 0; step < PALETTE.length && used.has(idx); step++) {
      idx = (idx + 1) % PALETTE.length;
    }
    used.add(idx);
    map[c.id] = PALETTE[idx];
  });
  return map;
};

const initials = (name = '') => {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  return (parts[0][0] + (parts[1]?.[0] || '')).toUpperCase();
};

/**
 * Veli ekranlarindaki cocuk secici (Odemeler + Ogrencilerim ortak kullaniyor).
 * Tek cocuklu velilerde hic gosterilmiyor - secilecek bir sey yok.
 */
const ChildSelector = ({ children = [], value, onChange }) => {
  if (children.length <= 1) return null;

  const colors = assignChildColors(children);

  return (
    <Segmented
      value={value}
      onChange={onChange}
      options={children.map((c) => ({
        label: (
          <span className="flex items-center gap-1.5 px-1">
            {/*
              AYRILMIŞ ÇOCUK SOLUK + ROZETLİ. İki çocuklu velide biri devam
              edip biri ayrılmışken seçici ikisini aynı gösteriyordu ve veli
              hangisinin kayıtlı olduğunu anlayamıyordu (2026-09-13).
              Sekme KALDIRILMIYOR — ayrılmış çocuğun geçmişi, sertifikaları
              ve ödeme kayıtları görülebilmeye devam etmeli.
            */}
            <Avatar
              size={20}
              style={{ backgroundColor: colors[c.id], fontSize: 11, opacity: c.is_passive ? 0.45 : 1 }}
            >
              {initials(c.name)}
            </Avatar>
            <span style={c.is_passive ? { opacity: 0.65 } : undefined}>{c.name.split(' ')[0]}</span>
            {c.is_passive && <Tag color="default" style={{ marginInlineEnd: 0 }}>Devam etmiyor</Tag>}
          </span>
        ),
        value: c.id,
      }))}
    />
  );
};

export default ChildSelector;
